/*
 * @Author: wangqiang.alpha wangqiang.alpha@bytedance.com
 * @Date: 2024-01-02 10:41:46
 * @LastEditors: wangqiang.alpha wangqiang.alpha@bytedance.com
 * @LastEditTime: 2024-01-09 22:49:58
 * @FilePath: /antd-pc/src/configs/identity.ts
 * @Description:
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
 */
import {IMAGE_PREFIX} from "./global";

export const IDENTITY_ROLE = {
  huanzhe: 'huanzhe',
  huanzhefirends: 'huanzhefirends',
  doctor: 'doctor',
  other: 'other',
  lovely: 'lovely',
};

export const IDENTITY_ROLE_DESC = {
  huanzhe: '患者',
  huanzhefirends: '患者亲友',
  doctor: '医务工作者',
  other: '其他从业者',
  lovely: '爱心人士',
};

export const IDENTITY_LIST = [
  {
    image: `${IMAGE_PREFIX}/1704810316334huanzhe.png`,
    title: '我是患者',
    type: IDENTITY_ROLE.huanzhe,
  },
  {
    image: `${IMAGE_PREFIX}/1704810570626头像.png`,
    title: '我是患者的亲友',
    type: IDENTITY_ROLE.huanzhefirends,
  },
  {
    image: `${IMAGE_PREFIX}/1704810583704yisheng.png`,
    title: '我是医务工作者',
    type: IDENTITY_ROLE.doctor,
  },
  {
    image: `${IMAGE_PREFIX}/1704810594209qitacongyezhe.png`,
    title: '我是其他从业者',
    type: IDENTITY_ROLE.other,
  },
  {
    image: `${IMAGE_PREFIX}/1704810606298aixinrenshi.png`,
    title: '我是爱心人士',
    type: IDENTITY_ROLE.lovely,
  },
];

export const TITLE_OPTION = ['主治医师', '副主任医师', '主任医师', '其他'];
